import { uniq } from 'lodash';

/**
 * Converts a camelCase string (like 'assignedTo') into a readable
 * Title Case string (like 'Assigned To').
 */
const formatKey = (key) => {
  const formatted = key.replace(/([a-z])([A-Z])/g, '$1 $2');
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

/**
 * Takes a filter object and returns a single, readable string summarizing
 * all the non-empty applied filters.
 */
export const getAppliedFiltersSummary = (filters) => {
  if (!filters || typeof filters !== 'object') {
    return 'No filters applied.';
  }

  const activeFilters = Object.entries(filters)
    .filter(([, value]) => value && String(value).trim() !== '')
    .map(([key, value]) => {
      const displayKey = formatKey(key);

      const hiddenKeys = [
        'Group By',
        'Project Ids',
        'Portfolio Ids',
        'Report On',
      ];

      const hiddenValues = [
        'task',
        'createdBy',
        'isCompleted',
        'project',
        'assignee',
        'priority',
        'resolution',
        'dueDate',
        'tags',
        'creator',
        'portfolio',
      ];

      if (hiddenKeys.includes(displayKey) || hiddenValues.includes(value)) {
        return '';
      }

      const displayValue = Array.isArray(value)
        ? value.join(', ')
        : String(value).trim();
      return `${displayKey}: ${displayValue}`;
    })
    .filter(Boolean);

  if (activeFilters.length === 0) {
    return 'No filters applied.';
  }

  const formatter = new Intl.ListFormat('en', {
    style: 'long',
    type: 'conjunction',
  });
  return `Active filters: ${formatter.format(activeFilters)}.`;
};

export const getAllUniqueTaskIdsFromReport = (
  aggregatedData,
  groupedByCF,
  stackedByCF,
) =>
  uniq(
    aggregatedData?.reduce((result, aggregatedGroup) => {
      if (
        (stackedByCF && aggregatedGroup?.stack === 'novalue') ||
        (groupedByCF && aggregatedGroup?.group === 'novalue')
      ) {
        return result;
      }
      result.push(...(aggregatedGroup?.taskIds || []));
      return result;
    }, []),
  );

export const getTotalTasksCountFromBurnReport = (summary) =>
  summary?.totalTasks;
